import { render } from "./raisedPage.vue?vue&type=template&id=1f73a253"
import script from "./raisedPage.vue?vue&type=script&lang=js"
export * from "./raisedPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__